<template>
  <div class="container">
    <img src="static/img/banner3.png" alt="" />
    <div
      class="time"
      style="position: relative; line-height: 40px"
      @click="dayshowPicker = true"
    >
      <span>{{ year }}年{{ month }}月</span>
      <van-icon name="arrow-down" />
    </div>
    <div style="display: flex; flex-direction: row-reverse">
      <img
        src="static/img/zs04.png"
        style="width: 24vw; height: 8vw; flex-shrink: 0"
        alt=""
        @click="$router.push('/zhengshulist')"
      />
    </div>
    <van-popup v-model="dayshowPicker" round position="bottom">
      <van-datetime-picker
        @cancel="dayshowPicker = false"
        @confirm="onConfirm"
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :max-date="maxDate"
        :formatter="formatter"
      />
    </van-popup>
    <div class="tabs">
      <p
        @click="
          tab = 0;
          initperson();
        "
        :class="{ active: tab == 0 }"
      >
        志愿之星(个人)
      </p>
      <p
        @click="
          tab = 1;
          initorg();
        "
        :class="{ active: tab == 1 }"
      >
        志愿之星(组织)
      </p>
    </div>
    <div class="tabcontainer" v-show="tab == 0">
      <div
        class="flex"
        v-for="(item, index) in list"
        :key="index"
        @click="linkto('homepage', item.m_id)"
      >
        <img :src="item.img" class="tx" alt="" />
        <div>
          <div class="content" style="font-weight: bold">
            <p style="margin-right: 10px">{{ item.name }}</p>
            <p>{{ item.level_str }}</p>
          </div>
          <div class="content">
            <p style="margin-right: 10px">政治面貌：{{ item.politics_face }}</p>
          </div>
          <div class="content">
            <p>服务时长：{{ item.hours }}小时</p>
          </div>
          <div class="content">
            <p>所在组织：{{ item.org_name }}</p>
          </div>
          <div class="content">
            <p>所在区域：{{ item.address }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="tabcontainer" v-show="tab == 1">
      <div
        class="flex"
        v-for="(item, index) in listorg"
        :key="index"
        @click="urlchange(item.org_type, item.org_id)"
      >
        <img :src="item.img" class="org" alt="" />
        <div style="width: 100%">
          <div
            class="content"
            style="font-weight: bold; justify-content: space-between"
          >
            <p class="orgname">{{ item.org_name }}</p>
            <!-- <p style="white-space: nowrap">
              <van-icon name="friends-o" />{{ item.count }}
            </p> -->
          </div>
          <div class="content">
            <p>活动时长：{{ item.hours }}小时</p>
          </div>
          <div class="content">
            <p>创建时间：{{ item.create_date }}</p>
          </div>
          <div class="content">
            <p>所在区域：{{ item.address }}</p>
          </div>
          <div class="content" v-if="item.p_name">
            <p>挂靠组织：{{ item.p_name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "honor",
  data() {
    return {
      tab: 0,
      list: [],
      listorg: [],
      maxDate: new Date(),
      currentDate: new Date(),
      dayshowPicker: false,
      year: "",
      month: "",
    };
  },
  created() {
    let date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth();
    if (this.month == 0) {
      this.year -= 1;
      this.month = 12;
    }
    this.maxDate = new Date(this.year, this.month - 1);
    this.currentDate = this.maxDate;
    this.initperson();
    this.initorg();
  },
  methods: {
    onConfirm(val) {
      this.year = val.getFullYear();
      this.month = val.getMonth() + 1;
      this.initperson();
      this.initorg();
      this.dayshowPicker = false;
    },
    formatter(type, val) {
      if (type == "year") {
        return `${val}年`;
      } else if (type == "month") {
        return `${val}月`;
      }
      return val;
    },
    urlchange(type, id) {
      if (type == 1) {
        this.$router.push({
          name: "orginazationdetail",
          query: {
            id: id,
          },
        });
      }
      if (type == 2) {
        this.$router.push({
          name: "sjdetail",
          query: {
            id: id,
          },
        });
      }
    },
    linkto(url, id) {
      this.$router.push({
        name: url,
        query: {
          id: id,
        },
      });
    },
    initperson() {
      this.$axios({
        method: "post",
        url: "/api/home/rank_star",
        data: this.qs.stringify({
          year: this.year,
          month: this.month,
          type: "1",
        }),
      }).then((res) => {
        console.log(res.data);
        this.list = res.data.data;
      });
    },
    initorg() {
      this.$axios({
        method: "post",
        url: "/api/home/rank_star",
        data: this.qs.stringify({
          year: this.year,
          month: this.month,
          type: "2",
        }),
      }).then((res) => {
        console.log(res.data);
        this.listorg = res.data.data;
      });
    },
  },
};
</script>
<style scoped>
img {
  width: 100%;
  display: block;
}
.tabs {
  width: 80%;
  margin: 0 auto;
  border: 1px solid #f0f2f5;
  background: #f0f2f5;
  color: #303133;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  font-size: 14px;
  margin-top: 10px;
}
.tabs p {
  text-align: center;
  line-height: 36px;
  width: 100%;
}
.active {
  color: red;
  background: white;
}
.tabcontainer {
  padding: 10px;
}
.flex {
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0;
}
.content {
  margin-right: 10px;
  display: flex;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  padding: 5px;
}
.tx {
  width: 20vw;
  height: 20vw;
  border-radius: 50%;
  margin: 5px;
  object-fit: cover;
}
.org {
  width: 20vw;
  height: 16vw;
  object-fit: contain;
  border-radius: 5px;
  margin: 10px;
}
.orgname {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin-right: 10px;
}
.time {
  margin: 15px auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/honor.vue